import React, { useState, useEffect, useReducer, useRef } from 'react';
import { SFuncModal } from 'shj-components'
import { Form, Button, Divider, Row, Col, message, Input, Switch } from 'antd';
import { receiptRulesPlanMainUpdateById, receiptRulesPlanMain } from '@/services/fmsConfig'
const TextArea = Input.TextArea;
export function modalAddOrEditFn({ fn, ...rest }) {

  const onClose = () => {
    dialog.destroy();
  };
  
  const dialog = SFuncModal({
    title: `${rest?.id ? rest?.showCopy ? '复制' : '编辑' : '新增'}`,
    width: 500,
    vanish: true,
    content: <ModalAddOrEditDom onClose={onClose} fn={fn} {...rest} />,
  });

  return dialog;
}

const ModalAddOrEditDom = ({ onClose, fn, ...rest }) => {
  const [form] = Form.useForm();
  const [addOrEditFooterLoading, setAddOrEditFooterLoading] = useState(false);
  const [addOrEditLoading, setAddOrEditLoading] = useState(false);
  useEffect(() => {
    initFn();
  }, []);

  const initFn = () => {
    const { id, name, remarks, isDefault } = rest;
    if (rest?.id) {
      // 回显数据
      if(rest?.showCopy){
        form.setFieldsValue({
          isCopyDetailId: id,
          name: '',
          remarks: '',
          isDefault: false
        });
      }else{
        form.setFieldsValue({
          id,
          name,
          remarks,
          isDefault
        });
      }
      
    }
  };
  // 重置
  const onReset = () => {
    form.resetFields();
  };
  // 保存并继续添加明细
  const onSubmit = () => {
    let newValues = { ...form.getFieldsValue() };
    const { id } = rest;
    newValues.isDefault = newValues.isDefault ? true : false
    setAddOrEditFooterLoading(true);
    if(id){
      receiptRulesPlanMainUpdateById({ ...newValues, ...(id && { id }) })
      .then((resp: any) => {
        console.log('resp',resp)
        setAddOrEditFooterLoading(false);
        message.info('操作成功');
        onClose();
        fn && fn(resp?.id);
      })
      .finally(() => {
        setAddOrEditFooterLoading(false);
      });
    }else{
      receiptRulesPlanMain({ ...newValues, ...(id && { id }) })
      .then((resp: any) => {
        console.log('resp',resp)
        setAddOrEditFooterLoading(false);
        message.info('操作成功');
        onClose();
        fn && fn(resp?.id);
      })
      .finally(() => {
        setAddOrEditFooterLoading(false);
      });
    }
  };
  // 保存
  const onFinish = (values: any) => {
    const { id } = rest;
    let newValues = { ...values };
    newValues.isDefault = newValues.isDefault ? true : false
    setAddOrEditLoading(true);
    if(id){
      // 复制
      if(rest.showCopy){
        receiptRulesPlanMain({ ...newValues, ...(id && { isCopyDetailId: id }) })
        .then((resp: any) => {
          setAddOrEditLoading(false);
          message.info(resp?.message || '复制成功');
          onClose();
          fn && fn();
        })
        .finally(() => {
          setAddOrEditLoading(false);
        });
      }else{
        receiptRulesPlanMainUpdateById({ ...newValues, ...(id && { id }) })
        .then((resp: any) => {
          setAddOrEditLoading(false);
          message.info(resp?.message || '操作成功');
          onClose();
          fn && fn();
        })
        .finally(() => {
          setAddOrEditLoading(false);
        });
      }
    }else{
      receiptRulesPlanMain({ ...newValues, ...(id && { id }) })
      .then((resp: any) => {
        setAddOrEditLoading(false);
        message.info(resp?.message || '操作成功');
        onClose();
        fn && fn();
      })
      .finally(() => {
        setAddOrEditLoading(false);
      });
    }
  };
  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };
  return (
    <div style={{ padding: 15 }}>
      <Form form={form} onFinish={onFinish}>
        <Form.Item
          label="收款计划名称"
          name="name"
          {...formItemLayout}
          rules={[{ required: true, message: '请输入收款计划名称' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="描述"
          {...formItemLayout}
          name="remarks"
          rules={[{ required: true, message: '请选输入描述' }]}
        >
          <TextArea rows={4} autoSize={false} maxLength={600} />
        </Form.Item>
        <Form.Item
          {...formItemLayout}
          label="是否默认"
          name="isDefault"
          style={{marginBottom: 8}}
        >
          <Switch disabled={rest.showCopy} />
        </Form.Item>
        <Form.Item style={{marginBottom: 10}}>
          <Row>
            <Col span={24}>
              <Divider />
            </Col>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button htmlType="button" onClick={onClose} style={{ marginLeft: '8px' }}>
                取消
              </Button>
              <Button type="primary" htmlType="submit" style={{ margin: '0 8px' }} loading={addOrEditLoading}>
                提交
              </Button>
              {
                !rest?.showCopy ?<Button type="primary" onClick={onSubmit} loading={addOrEditFooterLoading}>
                保存并继续添加明细
                </Button> : null
              }
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </div>
  );
};
